import { BronsonModal, filters, ModalProps } from '@dh/bronson-react';
import React from 'react';
import { BrandLinks } from '../../brandLinks.enum';
import { PorscheButton } from '../Button/button';
import { customClassModifierToModal } from './popup.constants';
import { LegalModal } from './popup.labels';
import { LegalPopUpProps } from './popup.type';

/**
 * This react function create the footer to legal pop up.
 * @returns LegalPopUpFooter comp.
 */
const LegalPopUpFooter: React.FC<{ closeMethod: () => void }> = ({
    closeMethod,
}) => {
    return (
        <div className='o-layout'>
            <div className='o-layout__item u-1/1'>
                <div className='o-button-container  o-button-container--right'>
                    <PorscheButton
                        id='modal-footer-btn'
                        onClick={() => closeMethod()}
                        label={LegalModal.btnTitle}
                    />
                </div>
            </div>
        </div>
    );
};

/**
 * This react function create the content to legal pop up.
 * @returns LegalPopUpContent comp.
 */
const LegalPopUpContent: React.FC<{ brandSelected: string }> = ({
    brandSelected,
}) => {
    const brandLowerCase = brandSelected.toLocaleLowerCase();
    const brand = filters.capitalize(brandSelected);
    const linkLabel = BrandLinks[brandLowerCase];
    const subLabel =
        LegalModal.labels2[brandLowerCase] || LegalModal.labels2.default;
    const mainLabel =
        LegalModal.labels1[brandLowerCase] || LegalModal.labels1.default;
    return (
        <label>
            <label>
                {`${mainLabel} `}
                {brandLowerCase !== 'audi' && (
                    <a
                        href={linkLabel}
                        target='_blank'
                        className='c-link'
                        rel='noreferrer'
                    >
                        <span className='c-link__body'>
                            <span className='c-link__effect'>{linkLabel}</span>
                        </span>
                    </a>
                )}
            </label>
            <br />
            <label className='u-mt-xsmall'>
                {subLabel.replace('{brand}', brand)}
            </label>
        </label>
    );
};

/**
 * This react function rendered the legal popup component.
 * @param param LegalPopUpProps.
 * @returns React.FC<LegalPopUpProps>;
 */
export const LegalPopUp: React.FC<LegalPopUpProps> = ({
    isHidden,
    onClose,
    brand,
}) => {
    const legalModalProps: ModalProps = {
        footerCloseButton: false,
        footerElements: [
            <LegalPopUpFooter closeMethod={() => onClose(true)} />,
        ],
        isHidden,
        title: '',
        content: <LegalPopUpContent brandSelected={brand} />,
        onClose: () => onClose(false),
        customClassModifier: customClassModifierToModal,
    };

    return <BronsonModal {...legalModalProps} />;
};
